import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { orderIdHelpByProvider } from './constants'
import * as Styles from './styles'

const OrderIdHelp = ({ storeProvider }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const orderIdHelp = orderIdHelpByProvider[storeProvider]

  if (!orderIdHelp) {
    return (
      <Text type="bodySRegular">
        {t(
          'El ID interno del pedido en tu plataforma. No es el número de pedido que ve el cliente (ej. #2030): es fácil de adivinar y no es seguro.'
        )}
      </Text>
    )
  }

  return (
    <Styles.Container>
      <Text type="bodySRegular">{t(orderIdHelp.description)}</Text>
      <Styles.Example>
        <Text type="bodyXSRegular" color={theme.colors.text.muted}>
          {t('Ejemplo')}
        </Text>
        <Text type="bodySRegular">{t(orderIdHelp.example)}</Text>
      </Styles.Example>
    </Styles.Container>
  )
}

export default OrderIdHelp
